import { Injectable } from '@angular/core';
import { PatientQuestionaireResponse } from '../models/patient-questionnaire';
import { environment } from '../../environments/environment';
import { SurveyAnswerResposne, SurveyResponse } from '../models/survey-response';

@Injectable({
  providedIn: 'root'
})
export class EpreopApiService {
  readonly setAnswersUrl = environment.setAnswersUrl;
  readonly getSurveyUrl = environment.getSurveyUrl;

  async getSurveyById(id: string): Promise<PatientQuestionaireResponse> {
    const data = await fetch(`${this.getSurveyUrl}patientQuestionnaireId=${id}`);
    return (await data.json()) ?? {};
  }

  async sendSurveyData(id: string, surveyResponse: SurveyResponse): Promise<SurveyAnswerResposne> {
    const data = await fetch(`${this.setAnswersUrl}patientQuestionnaireId=${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(surveyResponse)
    })
    return (await data.json()) ?? {};
  }
}
